import { jsxs as o, Fragment as t, jsx as r } from "react/jsx-runtime";
const n = () => /* @__PURE__ */ o(t, { children: [
  /* @__PURE__ */ r(
    "path",
    {
      d: "M2 8.00346C3.97671 9.36768 5.02329 9.3969 7 8.00346C8.98357 6.67664 10.0503 6.69826 12 8.00346C13.9481 9.32927 15.0934 9.31072 17 8.00346C18.9454 6.67912 20.051 6.65198 22 8.00346",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ r(
    "path",
    {
      d: "M2 12.0035C3.97671 13.3677 5.02329 13.3969 7 12.0035C8.98357 10.6766 10.0503 10.6983 12 12.0035C13.9481 13.3293 15.0934 13.3107 17 12.0035C18.9454 10.6791 20.051 10.652 22 12.0035",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ r(
    "path",
    {
      d: "M2 16.0035C3.97671 17.3677 5.02329 17.3969 7 16.0035C8.98357 14.6766 10.0503 14.6983 12 16.0035C13.9481 17.3293 15.0934 17.3107 17 16.0035C18.9454 14.6791 20.051 14.652 22 16.0035",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] });
export {
  n as default
};
